import Vue from 'vue'
import Vuex from 'vuex'
import CartService from '../components/cart-details/cart-details.service.js'
import cart from './cart/cart.store'
import configuration from './configuration/configuration.store'
import ConfigurationService from '../components/configuration/configuration.service.js'
import { CONSTANT } from '../utils/constant'
import lightboxstore from './lightbox/lightbox.store'

const cartService = new CartService()
const configurationService = new ConfigurationService()

Vue.use(Vuex)

export const state = {
  isLoaderOn: false,
  allEnvironments: ['Production', 'Sandbox', 'Stage', 'ITF'],
  allSdkLoaded: false,
  transactionAmount: 100
}

export const getters = {
  loaderOn (state) {
    return state.isLoaderOn
  },

  srcTotalPrice () {
    return JSON.parse(localStorage.getItem('srcTotalPrice') || 0).toFixed(2) || ''
  },

  allEnvironments () {
    return state.allEnvironments
  },

  allSdkLoaded () {
    return state.allSdkLoaded
  },

  cartTotalPrice () {
    let cartPrice = configurationService.getConfigData().storefront.quickCart.totalPrice
    cartPrice = parseFloat(cartPrice).toFixed(2) || 100.00
    return parseFloat(cartPrice)
  },

  transactionAmount () {
    return Number(state.transactionAmount.toFixed(2))
  }
}

export const actions = {
  appInit ({ commit }) {
    commit('setData')
  },

  loaderOn ({ commit }, isLoading) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('loaderOn', isLoading)
        resolve()
      }, 100)
    })
  },

  updateAllEnvironments ({ commit }, value) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('changeAllEnvironments', value)
        resolve()
      }, 100)
    })
  },

  updateAllSdkLoaded ({ commit }, value) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('changeAllSdkLoaded', value)
        resolve()
      }, 100)
    })
  },

  updateSRCTotalPrice ({ commit }, invokedFrom) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('updateSRCTotalPrice', invokedFrom)
        resolve()
      }, 100)
    })
  },

  updateTransactionAmount ({ commit }, transactionAmount) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('transactionAmount', transactionAmount)
        resolve()
      }, 100)
    })
  },

  setData ({ commit }) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('setData')
        resolve()
      }, 100)
    })
  }

}

export const mutations = {
  setData: function (state) {
    state.cart.cartContainer = cartService.getCartDetails()
    state.configuration = configurationService.getConfigData()
  },

  loaderOn (state, isLoading) {
    state.isLoaderOn = isLoading
  },

  changeAllEnvironments (state, value) {
    state.allEnvironments = value
  },

  changeAllSdkLoaded (state, value) {
    state.allSdkLoaded = value
  },

  updateTransactionAmount (state, transactionAmount) {
    state.transactionAmount = transactionAmount
  },

  updateSRCTotalPrice (state, invokedFrom) {
    let totalPrice = 0.00
    if (invokedFrom === CONSTANT.SRC.CART || invokedFrom === CONSTANT.SRC.INLINE_CARD || invokedFrom === CONSTANT.SRC.POPUP_CART) {
      totalPrice = state.cart.cartContainer.totalPrice
    } else if (invokedFrom === CONSTANT.SRC.CONFIGURATION) {
      totalPrice = state.configuration.storefront.quickCart.totalPrice
    }
    localStorage.setItem('srcTotalPrice', totalPrice)
    localStorage.setItem('invokedFrom', invokedFrom)
    state.transactionAmount = totalPrice
  }

}

export const store = new Vuex.Store({
  state,
  getters,
  actions,
  mutations,

  modules: {
    cart,
    configuration,
    lightboxstore
  }
})
